import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ref } from 'vue';

type Size = 'x-small' | 'small' | 'default' | 'large' | 'x-large';

export default /*@__PURE__*/_defineComponent({
  __name: 'CopyElement',
  props: {
    copyText: {},
    size: { default: 'default' }
  },
  setup(__props: any) {

const props = __props;
const isShowTooltip = ref(false);
const prevTimeoutId = ref(0);

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
  showTooltip();
};

const showTooltip = () => {
  isShowTooltip.value = true;
  clearTimeout(prevTimeoutId.value);
  prevTimeoutId.value = setTimeout(() => {
    isShowTooltip.value = false;
  }, 2000);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    variant: "text",
    icon: "",
    density: "compact",
    size: __props.size,
    onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(__props.copyText)))
  }, {
    default: _withCtx(() => [
      (!isShowTooltip.value)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            icon: "mdi-content-copy"
          }))
        : _createCommentVNode("", true),
      (isShowTooltip.value)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            icon: "mdi-check-bold",
            style: {"color":"#43A047"}
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_tooltip, {
        modelValue: isShowTooltip.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowTooltip).value = $event)),
        activator: "parent",
        "open-on-hover": false,
        location: "bottom",
        "update:modelValue": false
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("コピーしました", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["size"]))
}
}

})